exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teksatir[data-v-7322c259]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:220px}", ""]);

// exports
